let state = {
  //Array with all the events
  events: [],
};

export default state;
